var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_1547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0234 10.8817C19.257 10.089 20.2966 9.9057 20.7873 10.5707L29.4251 22.2779C29.6194 22.5412 29.9302 22.6928 30.2573 22.6838L44.8007 22.2828C45.6268 22.26 46.1224 23.1922 45.6416 23.8643L37.1766 35.6971C36.9862 35.9632 36.9381 36.3057 37.0477 36.614L41.9233 50.3217C42.2002 51.1003 41.4668 51.8597 40.6791 51.6101L26.8096 47.2159C26.4976 47.1171 26.157 47.1772 25.8977 47.3767L14.3675 56.2495C13.7126 56.7535 12.7638 56.2907 12.7577 55.4644L12.6509 40.9158C12.6485 40.5886 12.4861 40.2832 12.2162 40.0983L0.214604 31.8743C-0.467076 31.4072 -0.32015 30.3617 0.463878 30.1006L14.2674 25.5033C14.5778 25.3999 14.8181 25.1511 14.9106 24.8372L19.0234 10.8817Z",
    fill: "#F2E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 1L57.5497 7.45032L64 11L57.5497 14.5497L54 21L50.4503 14.5497L44 11L50.4503 7.45032L54 1Z",
    fill: "#D7BDFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 11,
    r: 2,
    fill: "#AF7BFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 34,
    r: 2,
    fill: "#AF7BFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 62,
    r: 2,
    fill: "#AF7BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_1547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.9aa16c6e5b670ec8d1e70556141a673d.svg";
export { ForwardRef as ReactComponent };